export default {"src":"/_next/static/media/pano.fd9f5266.svg","height":22,"width":88,"blurWidth":0,"blurHeight":0};